export default function genererCritereRechercheLigneCommande() {
  return {
    auto: '',
    types: [],
    tiersId: [],
    typesProduits: [],
    typesDevisCommandeFacture: [],
    etatsDevisCommandeFacture: [],
    dateVisualisation: null,
    sens: null,
    societeId: null,
    commercialRelanceurIds: [],
    commercialRelanceIds: [],
  };
}
